import React from 'react';
import cn from 'classnames';
import { pluralize } from 'utils';
import Button from 'components/common/Button';
import Icon from 'components/common/Icon';

export default class ListingTotal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: this.props.collapsed
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      collapsed: !this.state.collapsed
    })
  }

  render() {
    const { pricePerNight, basePrice, totalPrice, nights, cleaningFee, light } = this.props;
    const rowClassName = cn("row no-gutters separator py-1", { "text-muted": light });
    const totalClassName = cn("row no-gutters py-1", { "font-weight-normal": !light, "text-title": light });
    const { collapsed } = this.state;
    const icon = collapsed ? 'dropdown' : 'dropup';
    return (
      <div className="listing-total">
        <div className={cn("listing-total-rows", { collapsed })}>
          <div className={rowClassName}>
            <div className="col">{pricePerNight} x {nights} {pluralize('night', nights)}</div>
            <div className="col text-right">{basePrice}</div>
          </div>
          <div className={rowClassName}>
            <div className="col">Final cleaning</div>
            <div className="col text-right">{cleaningFee}</div>
          </div>
          <div className={rowClassName}>
            <div className="col">VAT</div>
            <div className="col text-right">included</div>
          </div>
        </div>
        <div className={totalClassName}>
          <div className="col-auto mr-1">Total</div>
          <div className="col-auto">
            { this.props.collapsed && (
              <Button shape="circle" btnStyle="transparent" onClick={this.toggle}>
                <Icon icon={icon}/>
              </Button>
            )}
          </div>
          <div className="col text-right">{totalPrice}</div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ListingTotal.js